import * as state from './state.js';
let getters = {
    
};
export default getters;


// WEBPACK FOOTER //
// ./src/vuex/modules/habitUserInfo/getters.js